import '../../../src/styles/healthInfo.css';
import React, {useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';


import PORT_UP_GREEN_ICON from '../../images/port-up-green.png';
import PORT_DOWN_GREEN_ICON from '../../images/port-down-green.png';

import PORT_UP_RED_ICON from '../../images/port-up-red.png';
import PORT_DOWN_RED_ICON from '../../images/port-down-red.png';

import PORT_UP_LOADING_ICON from '../../images/port-up-orange.png';
import PORT_DOWN_LOADING_ICON from '../../images/port-down-orange.png';

import { url } from '../../api/endpointURL';
import { ClipLoader } from 'react-spinners';
import Button from 'react-bootstrap/Button';

import { addPortCycleOutcome } from '../../redux/actions/portCycle';
import 'bootstrap/dist/css/bootstrap.min.css';

// Import generic components
import Tooltip from '../../generic_components/Tooltip/Tooltip';
import Modal from '../../generic_components/Modal/Modal';
import Table from '../../generic_components/Table/Table';
import { useToast } from '../../generic_components/Toast/Toast';


const Port = ({filtered_port, server, user, position}) => {
    const INTERVAL = 30000 // 30 secs
    const TIMEOUT = 180000 // 3 minutes. Average 3 minutes to complete the port-cycle
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showOutcomePopup, setShowOutcomePopup] = useState(false);
    const [showPendingRequestPopup, setShowPendingRequestPopup] = useState(false);
    const [otherUser, setOtherUser] = useState(null);
    const [toastID, setToastID] = useState(null);
    // const isSmallScreen = window.innerWidth < 600;

    const dispatch = useDispatch();
    const toast = useToast();

    const [loadingPortCycle, setLoadingPortCycle] = useState({
        switch_id: server.switchInfo.switch_id,
        port_id: filtered_port.port_id,
        loading: null, 
        completed: null,
        outcome: null,
        power_consumption: filtered_port.power_consumption, 
        timeLeft: 0,
        timeTaken: 0
    });

    // For printing only. DELETE LATER
    // useEffect(() => {
    //     console.log(`Line 41 the loadingPortCycle is ${JSON.stringify(loadingPortCycle, null, 2)} `);
    // }, [loadingPortCycle.timeLeft])
    
    // Handle open port-cycle popup and fetch port-cycle-outcome API
    const handleOpenPortCyclePopUp = async(portID, portNumber, portName) => {
    setShowConfirmation(false);

    const portData = {port_id: portID, event_creator: user};

    try {
        const response = await fetch(`${url}/port-cycle`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify(portData),  
        });

        // After dispatching a port cycle, if status is 200,
        if (response.status === 200) {
            // console.log(`Line 256                                       API SUCCESSFUL    `);
            // Dismiss the old toast
            toast.dismiss(toastID);

            //  Set its loading state to 'true' and initise timeLeft to 3 mins
            setLoadingPortCycle((prevState) => (
                    {...prevState, loading: true, completed: null, outcome: null, timeLeft: TIMEOUT/1000, timeTaken: 0}
            ));
    
            // Call the port-cycle-outcome API for 3 minutes every 30 seconds 
            start_port_cycle_polling_process(portID, portNumber, portName);
    }
        // If status is 202, the request is already pending by someone 
        else if (response.status === 202) {
            setShowPendingRequestPopup(true);
            const data = await response.json();
            // console.log(`Line 75 pending request from ${data.user}`); 
            setOtherUser(data.user);
        }
    }
    catch (error) {
        console.error('Error:', error);
    }
    }

    // Calling port-cycle-outcome API
    const call_port_cycle_outcome_api = async(portID, timeInterval, timeOut) => {
        const portData = {port_id: portID, event_creator: user};

        try {
            const response = await fetch(`${url}/port-cycle-outcome`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(portData), 
            });

            const data = await response.json();
            // console.log(`Line 323 the response data of port-cycle-outcome is ${JSON.stringify(data)}`);

            // when the port-cycle-outcome API returns 'complete' : 1 then stop the polling
            if (data.complete === 1) {
                clearInterval(timeInterval);
                clearTimeout(timeOut);
                // console.log("Polling stopped because the port-cycle completed.");

                setLoadingPortCycle((prevState) => (
                {...prevState, loading: false, completed: data.complete, outcome: data.outcome, power_consumption:data.power_consumption}
                ));

                let toast_id = null;

                if (data.outcome === 1) {
                    toast_id = toast.success(
                        <div>
                            <span className="toast-outcome">Port {filtered_port.port_number} - Camera {filtered_port.port_name}</span>                            
                            <div className="status-container">
                                <span className="port-cycle-status">Online!</span>
                                <span className="view-details"><i className="fa fa-eye"></i>Click to view details</span>
                            </div>
                        </div>
                        , {
                        onClick: () => setShowOutcomePopup(true),
                        theme: "colored",
                        autoClose: false 
                    });
                }
                else if (data.outcome === 0) {
                    toast_id = toast.error(
                        <div>
                            <span className="toast-outcome">Port {filtered_port.port_number} - Camera {filtered_port.port_name}</span>
                            <div className="status-container">
                                <span className="port-cycle-status">Offline!</span>
                                <span className="view-details"><i className="fa fa-eye"></i>Click to view details</span>
                            </div>
                        </div>
                        , {
                        onClick: () => setShowOutcomePopup(true),
                        theme: "colored",
                        autoClose: false 
                    });
                }

                setToastID(toast_id);
            }
            return data;
        }
        catch(error){
            console.error('Error:', error);
            clearInterval(timeInterval);
            clearTimeout(timeOut);
        }
    }

    // Dispatch adding port-cycle outcome when port-cycle completes (complete = 1 and outcome = 0/1)
    useEffect (() => {
        if (loadingPortCycle.completed === 1 && loadingPortCycle.outcome !== null ) {
            // Add the port-cycle outcome to global portCycleOutcomes once port-cycle completes
            const portCycleOutcome = {
                switchID: server.switchInfo.switch_id,
                portNumber: filtered_port.port_number,
                portName: filtered_port.port_name,
                portOutcome: loadingPortCycle.outcome,
                timeTaken: formatTime(loadingPortCycle.timeTaken),
            }
            dispatch(addPortCycleOutcome(portCycleOutcome));
        }
    }, [loadingPortCycle.completed,
        loadingPortCycle.outcome,
        filtered_port.port_number,
        filtered_port.port_name,
        server.switchInfo.switch_id,
        loadingPortCycle.timeTaken,
        dispatch]
    );

    // Start the time out process for calling port-cycle-outcome API every 30 seconds for 2 minutes
    const start_port_cycle_polling_process = (portID, portNumber, portName) => {
        // Call the port-cycle-outcome API every 30 secs
        const timeInterval = setInterval(() => {
            call_port_cycle_outcome_api(portID, timeInterval, timeOut);
        }, INTERVAL);

        // Time out calling the port-cycle-outcome API after 3 mins
        const timeOut = setTimeout(() => {
            clearInterval(timeInterval);
            // set 'loading' to 'false' and 'timeLeft' to '0' once timed out (outcome remains null) 
            setLoadingPortCycle((prevState) => (
                {...prevState, loading: false, timeLeft: 0, timeTaken: TIMEOUT/1000} 
            ));

            let toast_id = null;
            // if outcome = 1, Success and outcome = 0, Failure
            if (filtered_port.port_status === 1) {
                toast_id = toast.success(
                    <div>
                        <span className="toast-outcome">Port {filtered_port.port_number} - Camera {filtered_port.port_name}</span>                            
                        <div className="status-container">
                            <span className="port-cycle-status">Online!</span>
                            <span className="view-details"><i className="fa fa-eye"></i>Click to view details</span>
                        </div>
                    </div>
                    , {
                    onClick: () => setShowOutcomePopup(true),
                    theme: "colored",
                    autoClose: false 
                });
            }
            else if (filtered_port.port_status === 0) {
                toast_id = toast.error(
                    <div>
                        <span className="toast-outcome">Port {filtered_port.port_number} - Camera {filtered_port.port_name}</span>
                        <div className="status-container">
                            <span className="port-cycle-status">Offline!</span>
                            <span className="view-details"><i className="fa fa-eye"></i>Click to view details</span>
                        </div>
                    </div>
                    , {
                    onClick: () => setShowOutcomePopup(true),
                    theme: "colored",
                    autoClose: false 
                });
            }

            setToastID(toast_id);

            // Add the port-cycle outcome to global portCycleOutcomes once port-cycle timed out
            const portCycleOutcome = {
                switchID: server.switchInfo.switch_id,
                portNumber: portNumber,
                portName: portName,
                portOutcome: null,
                timeTaken: formatTime(TIMEOUT/1000),
            }
            dispatch(addPortCycleOutcome(portCycleOutcome));

        }, TIMEOUT + 5000); // add extra 5 seconds so that the state has enough time to be updated after the 6th API runs

        return () => {
        clearInterval(timeInterval);
        clearTimeout(timeOut);
        }; 
    }

    // Handle port image click
    const handlePortImageClick = () => {
        setShowConfirmation(true);
    };

    // Countdown timer format. Format time as MM:SS (minutes:seconds)
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}`;
    };

    // Count down by 1
    useEffect(() => {
        let interval;
        if (loadingPortCycle.loading === true && loadingPortCycle.timeLeft > 0){
            interval = setInterval(() => {
                setLoadingPortCycle((prevState) => (
                {...prevState, timeLeft: prevState.timeLeft - 1, timeTaken: (TIMEOUT/1000 + 1) - prevState.timeLeft}    
                ))
            }, 1000)
        }
        return () => clearInterval(interval);
    }, [loadingPortCycle.timeLeft, loadingPortCycle.loading] );

    // Handle hiding the popup
    const cancelDelete = () => {
        setShowConfirmation(false);
    };

    // Handle hiding the outcome popup
    const cancelDelete1 = () => {
        setShowOutcomePopup(false);
        toast.dismiss(toastID);
    };

    // Handle hiding the pending request popup
    const cancelDelete2 = () => {
        setShowPendingRequestPopup(false);
    };

    // Set port image
    const portImage = (port_status, port_loading, port_complete, port_outcome) => {
        // Top row
        if (position === "top") {
            // Online
            if (port_status === 1) {
                if (port_loading === true) {
                    return PORT_UP_LOADING_ICON;
                }
                if ((port_complete === 1) && (port_loading === false)) {
                    if(port_outcome === 1){
                        return PORT_UP_GREEN_ICON;
                    }
                    else {
                        return PORT_UP_RED_ICON;
                    }  
                }
                return PORT_UP_GREEN_ICON; 
            }
            // Offline
            else {
                if (port_loading === true) {
                    return PORT_UP_LOADING_ICON;
                }
                if ((port_complete === 1) && (port_loading === false)) {
                    if(port_outcome === 1){
                        return PORT_UP_GREEN_ICON;
                    }
                    else {
                        return PORT_UP_RED_ICON;
                    }  
                }
                return PORT_UP_RED_ICON;
            }
        }
        // Bottom row
        else if (position === "bottom") {
            // Online
            if (port_status === 1) {
                if (port_loading === true) {
                    return PORT_DOWN_LOADING_ICON;
                }
                if ((port_complete === 1) && (port_loading === false)) {
                    if(port_outcome === 1){
                        return PORT_DOWN_GREEN_ICON;
                    }
                    else {
                        return PORT_DOWN_RED_ICON;
                    }  
                }
                return PORT_DOWN_GREEN_ICON; 
            }
            // Offline
            else {
                if (port_loading === true) {
                    return PORT_DOWN_LOADING_ICON;
                }
                if ((port_complete === 1) && (port_loading === false)) {
                    if(port_outcome === 1){
                        return PORT_DOWN_GREEN_ICON;
                    }
                    else {
                        return PORT_DOWN_RED_ICON;
                    }  
                }
                return PORT_DOWN_RED_ICON;
            }
        }
    }
    
    const port_outcome_columns = [
        { key: 'switchVendor', label: 'Switch Vendor' },
        { key: 'switchMac', label: 'Switch Mac' },
        { key: 'portNumber', label: 'Port Number' },
        { key: 'cameraName', label: 'Camera Name' },
        { key: 'cycleOutcome', label: 'Cycle Outcome' },
        { key: 'timeTaken', label: 'Time Taken' },
        { key: 'consumptionWatt', label: 'Consumption(Watt)' },
    ];


    const port_outcome_data = [
        { 
            switchVendor: server.switchInfo.switch_vendor, 
            switchMac: server.switchInfo.switch_id, 
            portNumber: filtered_port.port_number,
            cameraName: filtered_port.port_name,
            cycleOutcome: (loadingPortCycle.outcome === null 
                ? 
                <span style={{color: filtered_port.port_status ? "#22BE63" : "#C82333"}}>{filtered_port.port_status}</span>
                :
                <span style={{color: loadingPortCycle.outcome ? "#22BE63" : "#C82333"}}>{loadingPortCycle.outcome}</span>
            ),
            timeTaken: formatTime(loadingPortCycle.timeTaken),
            consumptionWatt: loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption
        },
    ];

return (
    <>
    {/* If port is online, set image icon color to GREEN */}
    {filtered_port.port_status === 1 ?                                     
    // For clicked port, retrieve its loading status, if its true, change the port to orange
        loadingPortCycle.loading ?
            <div className="port-icon-name">
                {position === "bottom" ?
                <> 
                    {/* <div className="port-name">
                        <p>{filtered_port.port_name}</p>
                        <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                    </div> */}
                    <p>{formatTime(loadingPortCycle.timeLeft)}</p>
                    <Tooltip 
                        content={
                            <>
                            <p>{filtered_port.port_name}</p>
                            <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                            </>
                        }
                        placement='bottom'
                    >
                    <img className="port-icon-onclick-disabled" src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" />
                    </Tooltip>
                    {/* <img className="port-icon-onclick-disabled" src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" /> */}
                    <ClipLoader 
                    className="custom-spinner"
                    color={"white"}
                    loading={true}
                    size={25}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                    />
                </>
                :
                <>
                    <ClipLoader 
                    className="custom-spinner"
                    color={"white"}
                    loading={true}
                    size={25}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                    />
                    <Tooltip 
                        content={
                            <>
                            <p>{filtered_port.port_name}</p>
                            <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                            </>
                        }
                        placement='top'
                    >
                    <img className="port-icon-onclick-disabled" src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" />
                    </Tooltip>
                    {/* <img className="port-icon-onclick-disabled" src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" /> */}
                    <p>{formatTime(loadingPortCycle.timeLeft)}</p>
                    {/* <div className="port-name">
                        <p>{filtered_port.port_name}</p>
                        <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                    </div> */}
                </>
                }
            </div>
        :
            // if loading = 'false' and complete = 'true' => Render the new outcome (0: red / 1: green)
            loadingPortCycle.completed === 1 ?
                <div className="port-icon-name">
                    {/* {position === "bottom" && 
                    <div className="port-name-bottom">
                        <p>{filtered_port.port_name}</p>
                        <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                    </div>
                    }
                    <img onClick={() => handlePortImageClick()} className='port-icon' src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" />
                    {position === "top" &&                     
                    <div className="port-name">
                        <p>{filtered_port.port_name}</p>
                        <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                    </div>} */}
                    <Tooltip 
                        content={
                            <>
                            <p>{filtered_port.port_name}</p>
                            <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                            </>
                        }
                        placement={position==='bottom'?'bottom':'top' }
                    >
                    <img onClick={() => handlePortImageClick()} className='port-icon' src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" />
                    </Tooltip>
                </div>
            :
                // if loading = 'false' and 'complete' != 'true' => Leave image as it is
                <div className="port-icon-name">
                    {/* {position === "bottom" &&                     
                    <div className="port-name-bottom">
                        <p>{filtered_port.port_name}</p>
                        <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                    </div>}
                    <img onClick={() => handlePortImageClick()} className='port-icon' src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" />
                    {position === "top" &&                     
                    <div className="port-name">
                        <p>{filtered_port.port_name}</p>
                        <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                    </div>} */}
                    <Tooltip 
                        content={
                            <>
                            <p>{filtered_port.port_name}</p>
                            <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                            </>
                        }
                        placement={position==='bottom'?'bottom':'top' }
                    >
                    <img onClick={() => handlePortImageClick()} className='port-icon' src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" />
                    </Tooltip>
                </div>
    :
    // If port is offline, set image icon color to RED 
        // For clicked port, retrieve its loading status, if its true, change the port to orange
        loadingPortCycle.loading ?
            <div className="port-icon-name">
                {position === "bottom" ?
                    <>
                        {/* <div className="port-name-bottom">
                            <p>{filtered_port.port_name}</p>
                            <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                        </div> */}
                        <p>{formatTime(loadingPortCycle.timeLeft)}</p>
                        <Tooltip 
                            content={
                                <>
                                <p>{filtered_port.port_name}</p>
                                <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                                </>
                            }
                            placement='bottom'
                        >
                        <img className="port-icon-onclick-disabled" src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" />
                        </Tooltip>

                        {/* <img className="port-icon-onclick-disabled" src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" /> */}
                        <ClipLoader 
                        className="custom-spinner"
                        color={"white"}
                        loading={true}
                        size={25}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                        />
                    </>
                :
                    <>
                        <ClipLoader 
                        className="custom-spinner"
                        color={"white"}
                        loading={true}
                        size={25}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                        />
                        <Tooltip 
                            content={
                                <>
                                <p>{filtered_port.port_name}</p>
                                <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                                </>
                            }
                            placement='top'
                        >
                        <img className="port-icon-onclick-disabled" src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" />
                        </Tooltip>
                        {/* <img className="port-icon-onclick-disabled" src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" /> */}
                        <p>{formatTime(loadingPortCycle.timeLeft)}</p>
                        {/* <div className="port-name">
                            <p>{filtered_port.port_name}</p>
                            <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                        </div> */}
                    </>
                }
            </div>
        :
            // if loading = 'false' and complete = 'true' => Render the new outcome (0: red / 1: green)
            loadingPortCycle.completed === 1 ?
                <div className="port-icon-name">
                    {/* {position === "bottom" &&                     
                    <div className="port-name-bottom">
                        <p>{filtered_port.port_name}</p>
                        <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                    </div>}
                    <img onClick={() => handlePortImageClick()} className='port-icon' src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" />
                    {position === "top" &&                     
                    <div className="port-name">
                        <p>{filtered_port.port_name}</p>
                        <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                    </div>} */}
                    <Tooltip 
                        content={
                            <>
                            <p>{filtered_port.port_name}</p>
                            <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                            </>
                        }
                        placement={position==='bottom'?'bottom':'top' }
                    >
                    <img onClick={() => handlePortImageClick()} className='port-icon' src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" />
                    </Tooltip>
                </div>
            :
                // if loading = 'false' and 'complete' != 'true' => Leave image as it is
                <div className="port-icon-name">
                    {/* {position === "bottom" &&                     
                    <div className="port-name-bottom">
                        <p>{filtered_port.port_name}</p>
                        <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                    </div>}
                    <img onClick={() => handlePortImageClick()} className='port-icon' src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" />
                    {position === "top" &&                     
                    <div className="port-name">
                        <p>{filtered_port.port_name}</p>
                        <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                    </div>} */}
                    <Tooltip 
                        content={
                            <>
                            <p>{filtered_port.port_name}</p>
                            <p>Power: {loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}W</p>
                            </>
                        }
                        placement={position==='bottom'?'bottom':'top' }
                    >
                    <img onClick={() => handlePortImageClick()} className='port-icon' src={portImage(filtered_port.port_status, loadingPortCycle.loading, loadingPortCycle.completed, loadingPortCycle.outcome)} alt="port_icon" />
                    </Tooltip>
                </div>
        }

    {/* Pop up to ask user if they want to perform a port-cycle */}
    <Modal size='sm' show={showConfirmation} onHide={cancelDelete} className="custom-modal">
        <Modal.Header closeButton >
            <Modal.Title>
            <span style={{ color:'white', fontSize: 'medium' }}>
                Perform port-cycle
            </span>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div style={{ marginBottom: '1em' }}>
            Do you want to perform a port-cycle on <b>Port {filtered_port.port_number}</b> - <b>Camera {filtered_port.port_name}</b>? It may take up to 3 minutes.
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {
            <Button variant="secondary" size='small' onClick={() => handleOpenPortCyclePopUp(filtered_port.port_id, filtered_port.port_number, filtered_port.port_name)}>Yes</Button>
            }
            <Button variant="ghost" size='small' onClick={cancelDelete}>Cancel</Button>
            </div>
        </Modal.Body>
    </Modal>

    {/* Pop up to show the outcome of the port-cycle request */}
    <Modal size='lg' show={showOutcomePopup} onHide={cancelDelete1} className="custom-modal">
        <Modal.Header closeButton closeVariant={'white'} className='delete-modal-header'>
            <Modal.Title>
            <span style={{ color:'white', fontSize: 'medium' }}>
                Port-cycle Outcome
            </span>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className='delete-modal-body'>
            {
            <div>  
                {/* <div className='table-container-outcome'>
                    <table id='outcome-table'>    
                    <thead>
                        <tr> 
                            <th>Switch Vendor</th>
                            <th>Switch Mac</th>                                                         
                            <th>Port Number</th>                                                         
                            <th>Camera Name</th>
                            <th>Cycle Outcome</th>
                            <th>Time Taken</th>
                            <th>Consumption(Watt)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{server.switchInfo.switch_vendor}</td>
                            <td>{server.switchInfo.switch_id}</td>
                            <td>{filtered_port.port_number}</td>
                            <td>{filtered_port.port_name}</td>
                            {loadingPortCycle.outcome === null 
                            ? 
                            <td style={{color: filtered_port.port_status ? "#22BE63" : "#C82333"}}>{filtered_port.port_status}</td>
                            :
                            <td style={{color: loadingPortCycle.outcome ? "#22BE63" : "#C82333"}}>{loadingPortCycle.outcome}</td>
                            }
                            <td>{formatTime(loadingPortCycle.timeTaken)}</td>
                            <td>{loadingPortCycle.power_consumption === '-' ? 0 : loadingPortCycle.power_consumption}</td>
                        </tr>
                    </tbody>
                    </table> 
                </div> */}
                <Table 
                    columns={port_outcome_columns}
                    data={port_outcome_data}
                />
            </div>
            }
        </Modal.Body>           
    </Modal>

    {/* Pop up to let current user know there is already a pending port-cycle request performed by someone*/}
    <Modal size='md' show={showPendingRequestPopup} onHide={cancelDelete2} className="custom-modal">
        <Modal.Header closeButton closeVariant={'white'} className='delete-modal-header'>
            <Modal.Title>
            <span style={{ color:'white', fontSize: 'medium' }}>
                Warning!
            </span>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className='delete-modal-body'>
            { otherUser === user ?
                <div style={{ marginBottom: '1em' }}>
                Please wait up to 5 minutes for your current port-cycle request for port <b>{filtered_port.port_number}</b> connected to camera <b>{filtered_port.port_name}</b> to be completed!
                </div>
            :
                <div style={{ marginBottom: '1em' }}>
                Please wait up to 5 minutes! A port-cycle request for port <b>{filtered_port.port_number}</b> connected to camera <b>{filtered_port.port_name}</b> is being processed by <b>{otherUser}</b> 
                </div>
            }
        </Modal.Body>           
    </Modal>
    </>
    )
}


export default Port;